import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { FormElement, QuestionnaireService } from './questionnaire.service';
import { ItemAddRowDirective } from '../item/item-addrow.directive';
var QuestionnaireElementComponent = /** @class */ (function () {
    function QuestionnaireElementComponent(logger, service, cdRef) {
        this.logger = logger;
        this.service = service;
        this.cdRef = cdRef;
        this.changeElement = new EventEmitter();
        this.other = false;
        this.msg = {};
        this.readonly = false;
        this.items = [];
        this.seq = 1;
        this.is_other_field = false;
    }
    QuestionnaireElementComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setVal();
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError();
            }
        });
    };
    QuestionnaireElementComponent.prototype.ngOnChanges = function (changes) {
        if (changes.other && !changes.other.firstChange && changes.other.previousValue && !changes.other.currentValue && this.is_other_field) {
            this.onEvent({}, 'delete', this.items.length - 1);
        }
        if (changes.val && !changes.val.firstChange) {
            this.setVal();
        }
    };
    QuestionnaireElementComponent.prototype.setVal = function () {
        this.items = [];
        if (this.val instanceof Array) {
            this.items = this.val;
            this.service.sortItems(this.items);
        }
        this.seq = 1;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            item.seq = this.seq++;
        }
        if (this.items.length === 0) {
            this.items.push(Object.assign(new FormElement(), { seq: this.seq++ }));
        }
        this.is_other_field = false;
        if (this.items[this.items.length - 1].is_other_field) {
            this.is_other_field = true;
        }
        this.addError();
        this.setCompRec();
    };
    QuestionnaireElementComponent.prototype.trackByItem = function (index, item) {
        return item.seq;
    };
    QuestionnaireElementComponent.prototype.onEvent = function (e1, e2, index) {
        if (e2 === 'add') {
            var element = new FormElement();
            element.seq = this.seq;
            if (this.is_other_field) {
                this.items.splice(this.items.length - 1, 0, element);
            }
            else {
                this.items.push(element);
            }
            this.seq++;
        }
        else if (e2 === 'delete') {
            if (this.is_other_field && this.items.length - 1 === index) {
                this.is_other_field = false;
            }
            this.items.splice(index, 1);
        }
        else if (e2 === 'up') {
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
        }
        else if (e2 === 'down') {
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
        }
        else if (e2 === 'other') {
            this.is_other_field = true;
            this.items.push(Object.assign(new FormElement(), { seq: this.seq, is_other_field: true }));
            this.seq++;
        }
        this.addError();
        this.setCompRec();
    };
    QuestionnaireElementComponent.prototype.onChange = function (e, key, index) {
        this.items[index][key] = e.val;
        this.setCompRec();
    };
    QuestionnaireElementComponent.prototype.setCompRec = function () {
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (!item.is_other_field) {
                item.key = i + 1;
            }
            item.disp_order = i + 1;
        }
        this.changeElement.emit(this.items);
    };
    QuestionnaireElementComponent.prototype.addError = function () {
        this.cdRef.detectChanges();
        this.dir.addRequiredError((this.items.length === 0 ? true : false), this.msg['ColumnComponent.error.required']);
    };
    QuestionnaireElementComponent.prototype.ngOnDestroy = function () {
        this.subsc.unsubscribe();
    };
    QuestionnaireElementComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'questionnaire-element',
                    template: "<div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"{label: msg['au.COMPONENT.QuestionnaireElementComponent.label.options'], required: true}\" [msg]=\"msg\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\" itemAddRowDir>\n          <ul>\n            <li class=\"form_li form_li-w100per\">\n              <div class=\"tableWrapper\">\n                <table class=\"tableWrapper_table\">\n                  <thead>\n                  <tr data-href=\"#\">\n                    <th [hidden]=\"readonly\" scope=\"col\"></th>\n                    <th [hidden]=\"readonly\" scope=\"col\"></th>\n                    <th scope=\"col\"><a class=\"-fixed\"></a></th>\n                  </tr>\n                  </thead>\n                  <tbody>\n                  <ng-template ngFor let-item [ngForOf]=\"items\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n                    <tr data-href=\"#\" class=\"tr_cursorDefault\">\n                      <td [hidden]=\"readonly\" class=\"tableWrapper_arrowTd\">\n                        <ul *ngIf=\"!item.is_other_field\" class=\"stageFlow_arrows\">\n                          <li><a *ngIf=\"index > 0\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n                          <li><a *ngIf=\"(is_other_field && index < items.length - 2) || (!is_other_field && index < items.length - 1)\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li>\n                        </ul>\n                      </td>\n                      <td [hidden]=\"readonly\" class=\"tableWrapper_iconTd\">\n                        <a href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n                      </td>\n                      <td>\n                        <dl class=\"form\">\n                          <dt></dt>\n                          <dd class=\"form_dd\">\n                            <ul>\n                              <li *ngIf=\"!item.is_other_field\" class=\"form_li form_li-w100per\">\n                                <column-text *ngIf=\"!readonly\" [key]=\"'form'\" [col]=\"{\n                                  key: 'label-' + parent + '-' + item.seq,\n                                  controlType: 'text',\n                                  required: true\n                                }\" [val]=\"item.label\" [msg]=\"msg\" (changeVal)=\"onChange($event, 'label', index)\"></column-text>\n                                <column-formreadonly *ngIf=\"readonly\" [col]=\"{controlType: 'text'}\" [val]=\"item.label\" [msg]=\"msg\"></column-formreadonly>\n                              </li>\n                              <li *ngIf=\"item.is_other_field\" class=\"form_li form_li-w100per\">\n                                <label>{{ msg['au.COMPONENT.QuestionnaireElementComponent.label.is_other_field'] }}</label>\n                              </li>\n                            </ul>\n                          </dd>\n                        </dl>\n                      </td>\n                    </tr>\n                  </ng-template>\n                  </tbody>\n                </table>\n              </div>\n              <div class=\"row\">\n                <div class=\"col-sm-12\">\n                  <p *ngIf=\"!readonly\">\n                    <button class=\"addBtn\" type=\"button\" (click)=\"onEvent($event, 'add', '')\"></button>\n                    <a *ngIf=\"other && !is_other_field\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'other', '')\">{{ msg['au.COMPONENT.QuestionnaireElementComponent.label.add_other'] }}</a>\n                  </p>\n                </div>\n              </div>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    QuestionnaireElementComponent.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: QuestionnaireService },
        { type: ChangeDetectorRef }
    ]; };
    QuestionnaireElementComponent.propDecorators = {
        changeElement: [{ type: Output }],
        parent: [{ type: Input }],
        other: [{ type: Input }],
        val: [{ type: Input }],
        msg: [{ type: Input }],
        readonly: [{ type: Input }],
        dir: [{ type: ViewChild, args: [ItemAddRowDirective,] }]
    };
    return QuestionnaireElementComponent;
}());
export { QuestionnaireElementComponent };
//# sourceMappingURL=questionnaire-element.component.js.map